import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { AdminLayout } from '@/features/admin';
import { GuardPublicOnly } from '@/features/auth';

export function AdminPublicOnlyLayout() {
  return (
    <Suspense>
      <GuardPublicOnly>
        <AdminLayout navHidden>
          <Outlet />
        </AdminLayout>
      </GuardPublicOnly>
    </Suspense>
  );
}
